const ABORT_MISSION = {
  id: 'abort_mission',
  description: 'I must abandon my mission! I will contact you when I am safe.',
  response: {
    british: [{
      text: "Wise choice.  You are too valuable an asset to loose.  I'll find someone else to complete this mission.",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526070_1624448672.mp3',
    }, {
      text: "Your safety is of the utmost importance.  If you were to be captured, the almighty alone knows what they might do.  I'll find someone else loyal to the king to complete this mission.  God save the king!",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526073_1624448676.mp3',
    }, {
      text: "It may be best for you to leave town for the time being.  If these barbarous rebels were to capture you, I fear you would face a fate worse than death.  God save the king.",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526060_1624448650.mp3',
    }],
    american: [{
      text: "Wise choice.  You are too valuable an asset to loose.  I'll find someone else to complete this mission.",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526070_1624448672.mp3',
    }, {
      text: "Your safety is of the utmost importance.  If you were to be captured, it would be a severe blow to the cause of liberty.  I'll find another patriot to complete this mission.  Contact me again when you are able to undertake a new mission.",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526067_1624448664.mp3',
    }, {
      text: "It may be best for you to leave town for the time being.  Were the British to capture you, I fear you would face a fate worse than death.  My prayers will be with you.",
      audio: 'https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7526064_1624448659.mp3',
    }]
  },
}
export { ABORT_MISSION }